module.exports = __webpack_public_path__ + "static/media/step-2.c8379718.png";